/**
 * 视图配置常量和工具函数
 * 统一管理特殊视图的行为配置，避免代码分散
 */

/**
 * 强制使用时间排序的视图列表
 * 这些视图不应该被用户在 tag/tagGroup 中设置的排序方式影响
 */
export const FORCE_TIME_SORT_VIEWS = [
  'recent',        // 最近剪藏
  'uncategorized', // 未分类
  'starred',       // 已加星标
  'videos',        // 视频帖子（云端）
  'video',         // 视频帖子（本地）
] as const;

export type ForceTimeSortView = typeof FORCE_TIME_SORT_VIEWS[number];

/**
 * 判断给定视图是否应强制使用时间排序
 * @param view 视图标识（可以是 selectedTag 或 currentView）
 */
export function shouldForceTimeSort(view: string): boolean {
  return (FORCE_TIME_SORT_VIEWS as readonly string[]).includes(view);
}

/**
 * 根据视图获取实际应使用的排序方式
 * @param view 视图标识
 * @param userSortBy 用户设置的排序方式
 */
export function getEffectiveSortBy<T extends string>(
  view: string,
  userSortBy: T,
  timeSortValue: T = 'time' as T
): T {
  return shouldForceTimeSort(view) ? timeSortValue : userSortBy;
}
